AOS.init({
  duration: 800,
  once: true,
  disable: function () {
    return window.innerWidth < 768;
  }
});

// Category menu------------------------------
 var categorySelect = document.getElementById('categorySelect');

if (categorySelect) {

  // Redirect on change
  categorySelect.addEventListener('change', function () {
    var selectedOption = this.options[this.selectedIndex];
    var dataLink = selectedOption.getAttribute('data-link');

    if (dataLink) {
      window.location.href = dataLink;
    }
  });

  // Auto-select option based on URL
  setTimeout(function () {
    var currentPath = window.location.pathname;

    Array.prototype.forEach.call(categorySelect.options, function (option) {
      if (option.getAttribute('data-link') === currentPath) {
        option.selected = true;
      }
    });
  }, 800);

}
  // Close Category menu------------------------------








  // mobile tab --------------------------------
  document.querySelectorAll(".cmn-tab").forEach(function (item){
      item.addEventListener("click", function(){

        // active class add and remove
        const tabId = this.getAttribute("data-id");
        this.classList.toggle("active");

         const TabParent = Array.from(this.parentElement.children);
          TabParent.forEach(function (sibling) {
            if(sibling != this){
            sibling.classList.remove("active");
            }
          }, this);


        // bottom process

          const nextSibling = Array.from(this.parentElement.nextElementSibling.children);
           nextSibling.forEach(function (infoItem){
                const InfoId = infoItem.getAttribute("data-id");
                if(InfoId == tabId){
                    infoItem.style.display = "block";
                    infoItem.classList.add("active");

                    const infoParent = Array.from(infoItem.parentElement.children);
                     infoParent.forEach(function (infoparentitem){
                        if(infoparentitem != infoItem){
                            infoparentitem.style.display = "none";
                            infoparentitem.classList.remove("active");
                        }
                     });
                 }
               
               
           });
     

      });

   });






// Popup function
let ulTransVal = ''; // store globally

function openPopup(el) {
  const popup = document.querySelector('.cus-popup-new');

  if (popup) {
    ulTransVal = popup.getAttribute('style') || '';
  }

  const card = el.closest('.root-cause-card');
  if (!card) return;

  const overlay = card.querySelector('.pop-overlay-wrapper');
  const video = overlay?.querySelector('video');

  overlay.style.display = 'block';
  document.body.classList.add('over-follow-hidden');

  if (video) {
    video.currentTime = 0;
    video.play().catch(() => {});

    // Close popup automatically when video ends
    video.onended = () => {
      closePopup(video);
    };
  }
}

function closePopup(el) {
  const popup = document.querySelector('.cus-popup-new');

  // Restore Splide transform/style
  if (popup) {
    if (ulTransVal) {
      popup.setAttribute('style', ulTransVal);
    } else {
      popup.removeAttribute('style');
    }
  }

  const overlay = el.closest('.pop-overlay-wrapper');
  if (!overlay) return;

  const video = overlay.querySelector('video');

  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  overlay.style.display = 'none';
  document.body.classList.remove('over-follow-hidden');
}








  /* brands-logo.liquid js */
  // const isMobile = window.innerWidth <= 1024;
  // new Splide('.logos-wrap', {
  //   type: 'loop',
  //   perPage: isMobile ? 3 : 5,
  //   gap: '1rem',
  //   arrows: false,
  //   pagination: false,
  //   drag: isMobile,
  //   autoScroll: isMobile ? { speed: 1.5, pauseOnHover: true, pauseOnFocus: false, rewind: false } : false
  // }).mount(window.splide?.Extensions || {});

  document.querySelectorAll('.logos-wrap').forEach(item => {
    new Splide(item, {
    type: 'loop',
    perPage: 5,
    gap: '3rem',
    arrows: false,
    pagination: false,
    drag: false,
    autoScroll: false,
    breakpoints: {
      1024: {
        perPage: 3,
        drag: true,
        autoScroll: {
          speed: 1,
          pauseOnHover: true,
          pauseOnFocus: false,
          rewind: false,
        },
      },
    },
  }).mount(window.splide?.Extensions || {});

});



  /* target-root-causes-slider.liquid js */
  document.querySelectorAll('.root-slider').forEach(item => {
    new Splide(item, {
      type: 'loop',
      perPage: 4,
      focus: 'center',
      gap: '1rem',
      padding: { left: '0', right: '0' },
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3,
          padding: { left: '3rem',right: '3rem' }
        },
        991: {
          perPage: 2,
          padding: {left: '0', right: '0' }
        },
        767: {
          perPage: 1,
          padding: { left: '1rem',right: '1rem' }
        }
      }
    }).mount();
  });

  // document.querySelectorAll('.card-media').forEach(media => {
  //     const video = media.querySelector('video');
  //     const icon  = media.querySelector('.play-icon');

  //     if (!video || !icon) return;

  //     icon.addEventListener('click', () => {
  //         document.querySelectorAll('.card-media video').forEach(v => {
  //         if (v !== video) v.pause();
  //         });

  //         video.play();
  //     });

  //     video.addEventListener('click', () => {
  //         video.paused ? video.play() : video.pause();
  //     });

  //     video.addEventListener('play', () => {
  //         icon.style.display = 'none';
  //     });

  //     video.addEventListener('pause', () => {
  //         icon.style.display = 'flex';
  //     });

  //     video.addEventListener('ended', () => {
  //         icon.style.display = 'flex';
  //     });
  // });

document.querySelectorAll('#product-media-slider').forEach((item) => {

  const main = new Splide(item, {
    perPage    : 1,
    focus      : 'center',
    gap        : '0rem',
    arrows     : true,
    pagination : false,
  });

  const thumbSlider = item.closest('.product__media-wrapper').querySelector('#product-thumb-slider');

  const thumbnails = new Splide(thumbSlider, {
    perPage      : 5,
    focus        : 'center',
    gap          : '1rem',
    arrows       : false,
    pagination   : false,
    isNavigation : true,
    breakpoints: {
        767: {
          perPage: 4,
          padding: { left: '1.5rem', right: '4rem' }
        }
      }
  });

  main.sync(thumbnails);

  thumbnails.mount();
  main.mount();

});

document.querySelectorAll('#brand-marquee').forEach((item) => {
  new Splide(item, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      trimSpace  : false,
      arrows: false,
      pagination: false,
      perPage: 6,
      gap: '10px',
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        1460: {
          perPage: 5,
        },
        1200: {
          perPage: 4,
        },
        991: {
          perPage: 3,
        },
        640: {
          perPage:1,
           gap: '7px',
           padding: { left: '4rem', right: '4rem' }
        },
      },
    }).mount(window.splide.Extensions);
  });
 

  document.querySelectorAll('.specialists-slider').forEach((item) => {
    new Splide(item, {
      type: 'loop',
      perPage: 3,
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      focus: 'center',
      // gap: '10px',
      perMove: 1,
      arrows: false,
      pagination: false,
    }).mount();
  });


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.related__blogs .blog').forEach((wrapper) => {
    const slider = wrapper.querySelector('.related-blog-slider');
    const prevBtn = wrapper.querySelector('.custom-prev');
    const nextBtn = wrapper.querySelector('.custom-next');
    const arrowsWrap = wrapper.querySelector('.custom-splide-arrows');

    if (!slider) return;

    const splide = new Splide(slider, {
      type: 'slide',
      loop: false,
      perPage: 2,
      autoplay: false,
      interval: 1000,
      pauseOnHover: true,
      pauseOnFocus: true,
      gap: '20px',
      perMove: 1,
      arrows: false,
      pagination: false,
      padding: { left: '0', right: '7rem' },
      breakpoints: {
        767: {
          perPage: 1,
          gap: '10px',
          padding: { left: '2rem', right: '2rem' },
        },
      },
    });

    splide.mount();

    const slideCount = splide.Components.Elements.slides.length;

    if (arrowsWrap) {
      arrowsWrap.style.display = slideCount < 2 ? 'none' : 'flex';
    }

    // Function to update button disabled state
    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;

      const currIndex = splide.index;
      const lastIndex = slideCount - splide.options.perPage;

      prevBtn.disabled = currIndex === 0;
      nextBtn.disabled = currIndex >= lastIndex;
    };

    // Initial state
    updateArrows();

    // Listen to slide changes
    splide.on('move', updateArrows);

    // Arrow click events
    prevBtn?.addEventListener('click', () => splide.go('<'));
    nextBtn?.addEventListener('click', () => splide.go('>'));
  });
});


  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (event) {
      const hash = this.getAttribute('href');

      if (hash && hash !== '#') {
        const target = document.querySelector(hash);

        if (target) {
          event.preventDefault();

          const offsetTop = target.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });

          // Update URL hash after scroll
          history.pushState(null, '');
        }
      }
    });
});


document.querySelectorAll('.recommendations-blocks-wrap').forEach(item => {
  new Splide(item, {
      type       : 'loop', 
      direction : 'ttb',
      height    : '140px',
      perPage   : 1,
      gap       : '14px',
      arrows    : false,
      pagination: false,
      drag      : true,
      speed     : 700,
      autoplay: true,    
      interval: 3000, 
      easing    : 'cubic-bezier(.25,.8,.25,1)',
       breakpoints: {
        767: {
          height    : '100px',
        },
      },
  }).mount();
});

/* close menu drawer */
document.querySelectorAll('.menu-drawer-button-wrap .close').forEach(item => {
    item.addEventListener('click', function(){
        document.querySelector('header-drawer summary.header__icon').click();
    });
})

 // Add has-inner-banner class to the body if inner-banner exists
  document.addEventListener('DOMContentLoaded', function() {
    var innerBanner = document.querySelector('.has-top-bgimage');
    if (innerBanner) {
      document.body.classList.add('has-inner-topbanner');
    }
});


gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.matchMedia({

    "(min-width: 992px)": function () {

      const sections = gsap.utils.toArray(".how-it-works-step .hiw-block-wrap");

      sections.forEach((section, index) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: () => "+=" + section.offsetHeight,
          pin: true,
          pinSpacing: index === sections.length - 1,
          anticipatePin: 1,
          invalidateOnRefresh: true
        });
      });

    },

    "(max-width: 991px)": function () {

      ScrollTrigger.getAll().forEach(trigger => trigger.kill());

      gsap.set(".how-it-works-step .hiw-block-wrap", {
        clearProps: "all"
      });

    }

  });

  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });


// Get announcementbar Height
function updateAnnouncementHeight() {
  // Get the announcement custom bar element
  const announcementBar = document.querySelector('.utility-bar');
  // Check if the element exists
  if (announcementBar) {
    // Get the height
    const height = announcementBar.offsetHeight;
    // Set the CSS variable
    document.documentElement.style.setProperty('--announcement-height', `${height}px`);
  }
}
document.addEventListener("DOMContentLoaded", function() {
  // Update height when the DOM is fully loaded
  updateAnnouncementHeight();
  // Update height on window resize
  window.addEventListener('resize', updateAnnouncementHeight);
});





